<template>
    <div class="wrap">
        <div >
            <Banner></Banner>
        </div>
        <div class="content">
            <div class="title">
                <label>请填写您的账户信息</label>
            </div>
            <div class="item">
                <label>姓名:</label>
                <input type="text" placeholder="请填写" v-model="docAccount.name" readonly>
            </div>
            <div class="item" >
                <label>医院:</label>
                <input type="text" placeholder="请填写" v-model="docAccount.hospital" readonly>
            </div>
            <div class="item">
                <label>科室:</label>
                <input type="text" placeholder="请填写" v-model="docAccount.dept" readonly>
            </div>
            <div class="item">
                <label>开户名:</label>
                <input type="text" placeholder="请填写" v-model="docAccount.accountName">
            </div>
            <div class="item">
                <label>开户银行:</label>
                <input type="text" placeholder="请填写" v-model="docAccount.accountBank">
            </div>
            <div class="item">
                <label>开户账号:</label>
                <input type="text" placeholder="请填写" v-model="docAccount.accountId">
            </div>
            <div class="item">
                <label>身份证号:</label>
                <input type="text" placeholder="请填写" v-model="docAccount.idNumber">
            </div>
            <div class="item a">
                <label>选择身份证:</label>
            </div>
            <div class="idCard-wrap">
                <div class="item">
                    <div class="card-img">
                        <img id="img_1" :src="idShow(1)">
                        <input type="file" class="file" id="idCard-font" accept="image/*" @change="chooseIdCard(1,$event)" ref="idCard">
                    </div>
                    <div class="card-text">
                        <label>身份证正面</label>
                    </div>
                </div>
                <div class="item">
                    <div class="card-img">
                        <img id="img_2" :src="idShow(2)">
                        <input type="file" class="file" id="idCard-back" accept="image/*" @change="chooseIdCard(2,$event)" ref="idCard">
                    </div>
                    <div class="card-text">
                        <label>身份证反面</label>
                    </div>
                </div>
            </div>

            <div class="submit" @click="toSubmit">
                <label>{{submitInfo}}</label>
            </div>
        </div>

        <div class="success" v-if="dialogShow">
            <div class="close" @click="toStar">
                <img src="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/ksd/icon_close.png">
            </div>
            <div class="icon">
                <img src="https://ymd-lcc.oss-cn-beijing.aliyuncs.com/ksd/champion1.png" >
            </div>
            <div class="info">
                <span>恭喜您，完成任务</span>
            </div>
            <div class="info">
                <span>感谢您的支持</span>
            </div>
        </div>
    </div>
</template>

<script>
    import {ksdDocGetAccount, ksdDocAccount, getOssSecret} from "@/assets/js/api";
    import OSS from "ali-oss";
    import {getUuid} from "@/assets/util/util";
    import {Indicator} from "mint-ui";
    // import Signature from "@/components/ksd/sign/Signature";
    import Banner from "@/components/ksd/fragment/Banner";

    export default {
        name: "docInfo",
        components: {
            // Signature
            Banner
        },
        data() {
            return {
                docAccount:{
                    name: "",
                    hospital:"",
                    dept:"",
                    accountName:"",
                    accountBank:"",
                    accountId:"",
                    idNumber:"",
                    idCardFront:"",
                    idCardBack:"",
                    docId:this.$store.state.ksd_docId
                },
                option: {
                    penColor: "rgb(0, 0, 0)",//画笔颜色
                    backgroundColor: "rgb(245,245,245)"//背景颜色
                },
                watch:"查看",
                upload:"上传",
                submitInfo:"提交",
                payStandard:"劳务支付标准",
                station:"查询付款状态",
                deal:"劳务协议",
                ossKeySecret:'',
                ossPrefix:"ksd/id/",
                file1:null,
                file2:null,
                signShow:false,
                signInfo:"电子签名",
                dialogShow:false

            }
        },
        methods:{
            setSign(sign){
                console.log("getSetSign---",sign)
            },
            idShow(type){
              switch (type) {
                  case 1://正面
                      return this.docAccount.idCardFront!=""?this.docAccount.idCardFront:"https://ymd-lcc.oss-cn-beijing.aliyuncs.com/ksd/plus.png"
                  case 2://反面
                      return this.docAccount.idCardBack!=""?this.docAccount.idCardBack:"https://ymd-lcc.oss-cn-beijing.aliyuncs.com/ksd/plus.png"
              }
            },
            close(){
                this.signShow = false
            },
            chooseIdCard(type,event) {
                let fr = new FileReader();
                fr.readAsDataURL(event.target.files[0]);

                switch (type) {
                    case 1:
                        this.file1 = event.target.files[0]
                        fr.onload = function (e) {
                            document.getElementById('img_1').src = e.target.result;
                        };
                        break;
                    case 2:
                        this.file2 = event.target.files[0]
                        fr.onload = function (e) {
                            document.getElementById('img_2').src = e.target.result;
                        };
                        break;
                }

            },
           async getDocAccount(docId){
               const res = await ksdDocGetAccount({docId})
               this.docAccount = res.data.data
               console.log(res)
            },
            toSubmit(){
                console.log(this.docAccount,"docAccount====")
               if(this.docAccount.accountName==""){
                   this.$toast("开户名不能为空")
                   return;
               }
                if(this.docAccount.accountBank==""){
                    this.$toast("开户行不能为空")
                    return;
                }
                if(this.docAccount.accountId==""){
                    this.$toast("开户账号不能为空")
                    return;
                }
                if(this.docAccount.idNumber==""){
                    this.$toast("身份证号不能为空")
                    return;
                }
                if(this.file1==null&&this.docAccount.idCardFront==""){
                    this.$toast("请上传身份证正面照")
                    return;
                }
                if(this.file2==null&&this.docAccount.idCardBack=="")
                if(this.file2==null){
                    this.$toast("请上传身份证反面照")
                    return;
                }
                let _this =this
                Indicator.open({
                    text: '上传中',
                    spinnerType: 'fading-circle'
                });
                this.ossUpload(_this.file1,_this.docAccount.idCardFront).then(function (res) {
                    console.log(res,'正面上传成功')
                    _this.docAccount.idCardFront = res
                    _this.ossUpload(_this.file2,_this.docAccount.idCardBack).then(function (res) {
                        console.log(res,'反面上传成功')
                        _this.docAccount.idCardBack = res
                        _this.submit(_this.docAccount)
                    })

                })
            },
            toSign(){
              this.signShow = true;
            },
            toStar(){
                this.dialogShow=false
                this.$router.replace("docStar")
            },
            async submit(docAccount){
                const res = await ksdDocAccount({docAccount})
                if(res.data.success){
                    // this.$toast(res.data.message)
                    // this.$router.push("docStar")
                    this.dialogShow=true
                }
                Indicator.close();
            },
            async ossUpload(file,defaultLink){
                if(file==null){
                    return  defaultLink;
                }
                let client = new OSS({
                    region: 'oss-cn-beijing',
                    accessKeyId: 'LTAINtmi5XZ7NaV5',
                    accessKeySecret: this.ossKeySecret,
                    bucket: 'ymd-lcc'
                })

                let uuid = getUuid()
                uuid+=("."+file.name.split(".")[1])
                let key = this.ossPrefix + uuid

                let link=""
                await client.put(key, file).then(function (res) {
                    let str = res.res.requestUrls[0]
                    let status = res.res.status
                    if(status == 200){
                        const workLink =  str.split("?")[0];
                        link = workLink
                    }else {
                        this.$toast("上传失败")
                    }
                }).catch((err) => {
                    console.log(err,"异常啦")
                    this.$toast("无法获取视频，请更换手机重试")
                })

                return link
            },

            async getSecret(){
                const res = await getOssSecret();
                console.log(res)
                if(res.data.success==true){
                    this.ossKeySecret = res.data.data.accessKeySecret;
                }
            },
            //保存
            save() {
                var _this = this;
                var png = _this.$refs.signature.save();
                var jpeg = _this.$refs.signature.save("image/jpeg");
                var svg = _this.$refs.signature.save("image/svg+xml");
                console.log(png);
                console.log(jpeg);
                console.log(svg);
            },
            //清空
            clear() {
                var _this = this;
                _this.$refs.signature.clear();
            },
        },
        mounted(){
            console.log(this.docAccount.docId,"docId===")
            this.getDocAccount(this.docAccount.docId)
            this.getSecret()
        }
    }
</script>

<style scoped lang="scss">
    .wrap {
        width: 100%;
        height: 100vh;
        background: transparent url("https://ymd-lcc.oss-cn-beijing.aliyuncs.com/ksd/bg.png") no-repeat;
        background-size: 100% 100%;
        overflow: scroll;
        position: relative;
        font-size: 15px;
    }

    .content {
        flex-grow: 1;
    }

    .content {
        margin: 0 auto;
        width: 90%;
        display: flex;
        flex-direction: column;
        align-items: center;
        .title{
            text-align: center;
            color: #2c9a58;
            font-size: 18px;
            font-weight: bold;
        }
        .item {
            width: 100%;
            background: #ddd;
            text-align: left;
            margin-top: 10px;
            padding: 5px 0;
            border-radius: 5px;
            display: flex;
            flex-direction: row;
            align-items: center;
            label {
                margin-left: 5px;
            }
            input {
                text-indent: 5px;
                flex-grow: 1;
                background: transparent;
                border: none;
                outline: none;
                font-size: 15px;
                margin: 0;
                padding: 0;
            }
            .watch{
                text-align: left;
                label{
                }
            }
            .upload{
                background: #2c9a58;
                color: #FFF;
                margin-right: 20px;
                padding: 0 15px;
                border-radius: 5px;
                position: relative;
                .file{
                    position: absolute;
                    width: 50px;
                    height: 20px;
                    top: 0;
                    left: 0;
                    opacity: 0;
                }
            }
        }

        .disable{
            background: #aaa;
        }

        .a{
            background: transparent ;
            font-size: 16px;
        }

        .payStandard{
            width: 100%;
            text-align: left;
            label{
                background: #2c9a58;
                color: #FFF;
                padding: 2px 5px;
                border-radius: 5px;
            }
        }
    }
    .content .submit{
        width: 100%;
        margin: 10px auto;
        background: #2c9a58;
        text-align: center;
        border-radius: 5px;
        color: #FFF;
        padding: 5px 0;
    }

    .btn{
        width: 95%;
        margin: 30px auto;
        display: flex;
        flex-direction: row;
        justify-content: center;
        label{
            display: block;
            width: 50%;
            padding: 5px 0;
            color: #FFF;
            border-radius: 5px;
            background: #2c9a58;
        }
        label:first-child{
            margin-right: 5px;
        }
        label:last-child{
            margin-left:5px;
        }
    }


    ul{
        padding: 0 10px;
        margin: 2px;
    }

    li{
        list-style-type: none;
        margin: 2px 0;
    }

    .idCard-wrap{
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        background: #eee;
        /*margin: px 0;*/
    }

    .idCard-wrap .item{
        display: flex;
        flex-flow: column;
        width: 40%;
        align-items: center;
        justify-content: center;
        padding-top: 10px;

    }

    .idCard-wrap .item .card-img{
        position: relative;
        width: 120px;
        height: 80px;
        img{
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
        input{
            width:100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            opacity: 0;
        }
    }

    .idCard-wrap .item .card-text{
        margin-top: 10px;
        text-align: center;
        font-size: 14px;
    }

    .sign-wrap{
        position: absolute;
        width: 90%;
        height: 350px;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        background: #FFF;
        border-radius: 20px;
        .close{
            font-size: 18px;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 10px 0;
            position: relative;
            font-weight: normal;
            img{
                position: absolute;
                right: 20px;
                width: 25px;
                height: 25px;
            }
        }
    }

    .success{
        width: 80%;
        height: 350px;
        background: #FFF;
        position: fixed;
        top: 0%;
        left: 0%;
        right: 0%;
        bottom: 0;
        margin: auto;
        border-radius: 30px;
        font-weight: bold;
        .close{
            text-align: right;
            margin: 15px 15px 0 0 ;
            img{
                width: 30px;
                height: 30px;
            }
        }
        .icon{
            margin-top: 10px;
            img{
                width: 40%;
                object-fit: cover;
            }
        }
        .info{
            margin-top: 10px;
            font-size: 20px;
        }
    }


</style>